import './VideoEditButton.css';
import * as React from 'react';
import EditIcon from '@mui/icons-material/Edit';
import {
  FormControl,
  InputLabel, LinearProgress,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import VirtualAutoComplete from "../VirtualAutoComplete/VirtualAutoComplete";
import Divider from "@mui/material/Divider";
import SaveIcon from '@mui/icons-material/Save';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import FullScreenPopup from "../FullScreenPopup/FullScreenPopup";
import TitleWithText from "../TitleWithText/TitleWithText";
import {deleteData, getJsonData, postJsonData} from "../../Functions/Api";
import {LoadingButton} from "@mui/lab";

class VideoEditButton extends React.Component {
  state = {
    editing: false,
    savingChange: false,
    languages: [],
    categories: [],
    reciter: [],
    data: null
  }

  editedData = {}

  edit() {
    this.setState({editing: true, data: null});

    getJsonData(`/api/videos/languages`, (data) => this.setState({languages: data}));
    getJsonData(`/api/videos/categories`, (data) => this.setState({categories: data}));
    getJsonData(`/api/videos/reciter`, (data) => this.setState({reciters: data}));
    getJsonData(`/api/videos/${this.props.videoId}`, (data) => {
      this.editedData = {
        name: data.name,
        categoryId: data.categoryId,
        languageId: data.languageId,
        reciterName: data.reciterName,
      };

      this.setState({data: data});
    });
  }

  close() {
    this.setState({editing: false});
  }

  onFieldChange(key, value) {
    this.editedData[key] = value;
  }

  save() {
    this.setState({savingChange: true});

    if (this.editedData.reciterName) {
      let findReciterName = this.editedData.reciterName.trim().toLowerCase();
      this.editedData.reciterId = this.state.reciters.filter((reciter) => reciter.name.trim().toLowerCase() === findReciterName).map((reciter) => reciter.id)[0] || null;
    } else {
      this.editedData.reciterId = null;
    }

    postJsonData(`/api/videos/${this.props.videoId}/edit`, this.editedData, () => {
      if (this.props.onDataChanged) {
        this.setState({editing: false, savingChange: false})
        this.props.onDataChanged();
      }
    });
  }

  delete() {
    this.setState({savingChange: true});

    if (window.confirm("Are you sure you want to delete this video and all its parts from Jafri Library & Google Drive?")) {
      deleteData(`/api/videos/${this.props.videoId}`, () => {
        if (this.props.onDataChanged) {
          this.setState({editing: false, savingChange: false})
          this.props.onDataChanged();
        }
      });
    }
  }

  render() {
    return (
      <div className={this.props.className}>
        <div className="video-edit-button" onClick={this.edit.bind(this)}>
          <EditIcon/>
        </div>
        {
          this.state.editing &&
          <FullScreenPopup open={this.state.editing} onClose={this.close.bind(this)} title={"Edit Video"}>
            {
              this.state.data && this.state.reciters?.length
                ?
                <div className="video-edit-body">
                  <TitleWithText title="Edit Details" style={{marginTop: "1em"}}>
                    <div className="video-edit-form">
                      <TextField type="text" label="Video Name" defaultValue={this.state?.data?.name} onChange={(event) => this.onFieldChange("name", event.target.value)} fullWidth/>
                    </div>
                    <div className="video-edit-form">
                      <FormControl fullWidth>
                        <VirtualAutoComplete disableListWrap defaultValue={this.state?.data?.reciterName || ""} freeSolo
                                             options={this.state.reciters.map((option) => option.name)}
                                             onInputChange={(event, value) => this.onFieldChange("reciterName", value)}
                                             renderInput={(params) => <TextField {...params} label="Recited By"/>}/>
                      </FormControl>
                    </div>
                    <div className="video-edit-form">
                      <FormControl fullWidth>
                        <InputLabel>Category</InputLabel>
                        <Select label="Category" fullWidth
                                onChange={(event) => this.onFieldChange("categoryId", event.target.value)}
                                defaultValue={this.state?.data?.categoryId || ""}>
                          <MenuItem value="">
                            <em>None</em>
                          </MenuItem>
                          {this.state.categories?.map((category) => {
                            return <MenuItem key={category.id} value={category.id}>{category.name}</MenuItem>
                          })}
                        </Select>
                      </FormControl>
                    </div>
                    <div className="video-edit-form">
                      <FormControl fullWidth>
                        <InputLabel>Language</InputLabel>
                        <Select label="Language" fullWidth
                                onChange={(event) => this.onFieldChange("languageId", event.target.value)}
                                defaultValue={this.state?.data?.languageId || ""}>
                          <MenuItem value="">
                            <em>None</em>
                          </MenuItem>
                          {this.state.languages?.map((language) => {
                            return <MenuItem key={language.id} value={language.id}>{language.name}</MenuItem>
                          })}
                        </Select>
                      </FormControl>
                    </div>
                    <div style={{display: "flex"}}>
                      <LoadingButton loading={this.state.savingChange} loadingPosition="start" variant="contained" onClick={this.save.bind(this)} startIcon={<SaveIcon/>}>Save</LoadingButton>
                      <Divider sx={{m: 0.5}} orientation="vertical" flexItem/>
                      <LoadingButton loading={this.state.savingChange} loadingPosition="start" variant="contained" onClick={this.delete.bind(this)} startIcon={<DeleteForeverIcon/>} color={"error"}>Delete</LoadingButton>
                    </div>
                  </TitleWithText>
                </div>
                :
                <LinearProgress/>
            }
          </FullScreenPopup>
        }
      </div>
    );
  }
}

export default VideoEditButton;
